import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'
import type { ProviderRequestPayload } from '../../interfaces/providerRequests'

export interface PendingRequestsStore {
  pendingRequests: ProviderRequestPayload[]
  addPendingRequest: (request: ProviderRequestPayload) => void
  removePendingRequest: (id: string) => void
  clearPending: () => void
}

export const createPendingRequestsStore = (storage: StateStorage) =>
  createStore<PendingRequestsStore>(
    storage,
    (set) => ({
      pendingRequests: [],
      addPendingRequest: (newRequest) => {
        set((state) => ({
          pendingRequests: [...state.pendingRequests, newRequest],
        }))
      },
      removePendingRequest: (id) => {
        set((state) => ({
          pendingRequests: state.pendingRequests.filter((request) => request.id !== id),
        }))
      },
      clearPending: () => {
        set(() => ({
          pendingRequests: [],
        }))
      },
    }),
    {
      persist: {
        name: 'pendingRequestStore',
        version: 0,
      },
    }
  )
